import { render } from "./UserDashboardView.vue?vue&type=template&id=2ee87d7c"
import script from "./UserDashboardView.vue?vue&type=script&lang=js"
export * from "./UserDashboardView.vue?vue&type=script&lang=js"

import "./UserDashboardView.vue?vue&type=style&index=0&id=2ee87d7c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__